export default __webpack_public_path__ + "static/media/schedule-a-ride.15b3b851.svg";